<header class="header relative">
  <div [ngClass]="bxHeader ? 'bx-header justify-content-center justify-content-lg-start' : 'justify-content-center'" class="header-wrapper d-flex align-items-center gap24 w-100 h-100 py-12 px-24 py-28-768 px-48-768 gap-24-768  border-bottom-rgbaGrey500">
    <a class="ielts-logo" href="{{cxDomain}}">
      <img width="160" height="28" src="/assets/icons/idp_ielts_logo.svg" alt="IDP IELTS Logo" class="w-100 h-100"/>
    </a>
    @if (bxHeader) {
      <div class="progressbarWrapper d-lg-flex d-none w-100 justify-content-center position-absolute">
        <ul class="progressbar d-flex w-100">
          <li class="steps d-flex flex-column gap-16-768 w-100 position-relative heading6-768 font-semibold  txt-grey600-Set2 completed"><span class="step-circle"></span>Test date</li>
          <li class="steps d-flex flex-column gap-16-768 w-100 position-relative heading6-768 font-semibold txt-grey600-Set2 active"><span class="step-circle"></span>Account</li>
          <li class="steps d-flex flex-column gap-16-768 w-100 position-relative heading6-768 txt-grey600-Set2"><span class="step-circle"></span>Review</li>
          <li class="steps d-flex flex-column gap-16-768 w-100 position-relative heading6-768 txt-grey600-Set2"><span class="step-circle"></span>Payment</li>
          <li class="steps d-flex flex-column gap-16-768 w-100 position-relative heading6-768 txt-grey600-Set2"><span class="step-circle"></span>Profile & ID</li>
          <li class="steps d-flex flex-column gap-16-768 w-100 position-relative heading6-768 txt-grey600-Set2"><span class="step-circle"></span>Booking complete</li>
        </ul>
      </div>
    }
  </div>
  @if (bxHeader) {
    <div class="mobile-bar d-flex d-lg-none flex-column gap-10 px-24 py-16 justify-content-between border-bottom-rgbaGrey500">
      <h2 class="heading4 text-black text-center">Account</h2>
      <ul class="d-flex gap-8">
        <li class="steps-bar w-100 active"></li>
        <li class="steps-bar w-100 active"></li>
        <li class="steps-bar w-100"></li>
        <li class="steps-bar w-100"></li>
        <li class="steps-bar w-100"></li>
        <li class="steps-bar w-100"></li>
      </ul>
    </div>
  }
</header>
